import { mapValues } from 'lodash';

/**
 * Extract form data from formState
 *
 * @param {object} formState - Form state object
 * @returns {object} Extracted form data
 */
export default function getFormData(formState) {
  return mapValues(formState, 'value');
}
